import IJkelenstamShowroom from './../classes/showroom';

export default {
  init() {
    new IJkelenstamShowroom();

    // JavaScript to be fired on the about us page
  },
};
